import { LightboxService } from "features/gallery/lightbox/lightbox.service"
import { Post } from "suus-api"
import { usePostMediaPhotoswipe } from "features/posts/gallery/lightbox/use-post-media-photoswipe"
import { ViewContext } from "concerns/useContextName"

export class PostLightboxService {
  constructor(
    private _lightboxService: LightboxService,
    private _post: Post,
    private _viewContext: ViewContext
  ) {}

  openLightbox(startIndex: number) {
    const { openLightbox } = usePostMediaPhotoswipe(
      this._post.id,
      this._post.event_media_count,
      this._lightboxService,
      this._viewContext
    )
    openLightbox(startIndex)
  }
}
